export const RESOURCE_TYPE_CODE = 'SOFTWARE_CODE';
